<template>
  <div>
    <!--头部-->
    <div class="ele-page-header">
      <div class="ele-page-title">意见反馈</div>
      <div class="ele-page-desc">反馈给校讯通平台的客服</div>
    </div>
    <div class="ele-body">
      <el-card shadow="never">
        <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="90px" style="max-width: 700px; margin: 10px auto">
          <el-form-item label="内容:" prop="content">
            <el-input v-model="editForm.content" placeholder="请输入目标描述" :rows="4" type="textarea" />
          </el-form-item>
          <el-form-item label="附件:">
            <el-upload
              v-model="editForm.filePath"
              ref="uploadFile"
              :action="$http.defaults.baseURL + '/file/getFilePath'"
              name="multipartFile"
              :headers="$http.defaults.headers.common"
              :data="{ path: 'feedbackFile/' }"
              :limit="1"
              :before-upload="handleImageUpload"
              :on-success="uploadSuccess"
              :on-remove="removeFile"
              :on-exceed="exceed"
              :file-list="fileList"
            >
              <el-button size="small" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">上传文件不能超过10M</div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button @click="closeThis">关闭</el-button>
            <el-button type="primary" @click="submit" :loading="loading">提交</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
  import { addProblem } from '@/config/api';

  export default {
    name: 'Feedback',
    data() {
      return {
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          content: [{ required: true, message: '请输入内容', trigger: 'blur' }],
        },
        loading: false,
        fileList: [], //文件列表
      };
    },
    methods: {
      //文件上传之前
      handleImageUpload(file) {
        const fileSize = file.size / 1024 / 1024 < 10;
        if (!fileSize) {
          this.$message.error('上传文件不能超过5M');
          this.$refs.uploadFile.uploadFiles.pop(); //解决上传文件超过限制时，show-file-list为true时也显示不成功文件的bug
          return false;
        }
      },
      // 上传成功
      uploadSuccess(res, file) {
        if (res.resCode == 200) {
          this.editForm.filePath = res.data[0].fileUrl;
          this.fileList.push(file);
        }
      },
      // 限制个数
      exceed() {
        this.$message.warning('请最多上传1个文件。');
      },
      // 删除文件
      removeFile() {
        this.editForm.filePath = null;
      },
      // 提交
      submit() {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            this.loading = true;
            let data = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                data.append(key, this.editForm[key]);
              }
            }
            setTimeout(() => {
              addProblem(data).then((res) => {
                if (res.data.resCode == 200) {
                  this.loading = false;
                  this.$message({ type: 'success', message: '提交成功' });
                  this.editForm = {};
                  this.fileList = [];
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }, 1000);
          } else {
            return false;
          }
        });
      },
      closeThis() {
        this.$store.dispatch('theme/tabRemove', this.$route.fullPath).then((last) => {
          this.$router.push(last === -1 ? '/' : this.$store.state.theme.tabs[last].path);
        });
      },
    },
  };
</script>

<style scoped></style>
